import React from 'react';
import {ISegment} from '../../types/Filter';
import PillRow from './Pill';

interface CategoryPillsProps {
  categories: ISegment[];
  selectedCategory: string | null;
  onSelect: (categoryName: string | null) => void;
}

const CategoryPills = ({
  categories,
  selectedCategory,
  onSelect,
}: CategoryPillsProps) => (
  <PillRow
    items={(categories ?? []).map(cat => ({key: cat.name, label: cat.name}))}
    selectedKey={selectedCategory}
    onSelect={onSelect}
  />
);

export default CategoryPills;
